import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';
import moment from 'moment';

const TaskForm = forwardRef(({task, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={task}
      type="task"
      fieldsComponent={(props) => <Fields {...props}/>}
      onSave={useCallback(({title, assignee_id, description, deadline, priority, schedule}) => {
        const updates = {
          title,
          assignee_id,
          description,
          deadline: moment(deadline).format('YYYY-MM-DD'),
          priority,
          schedule: schedule ? schedule : null
        };
        return !task?.id ? services.task.createTask(updates) : services.task.updateTask(task, updates);
      }, [services, task])}
      onSaved={onSaved}
    />
  );
});

export default TaskForm;
